import { PLANTATION_VIEW_ERROR, PLANTATION_VIEW_POST_ERROR,PLANTATION_VIEW_SUCCESS , PLANTATION_EDIT_SUCCESS,CREATE_PLANTATION_SUCCESS,CREATE_PLANTATION_ERROR,CREATE_PLANTATION_POST_ERROR, PLANTATION_EDIT_ERROR} from "../actions/types";

export default (state = {  
    error: null,
    results:[],
    success:false,
    created:{}
}, action) => {
    switch (action.type) {
    case PLANTATION_VIEW_SUCCESS:
        return {    
        ...state,
        isSwitchSnackbarOn: true,
        isSnackbarError: false,
        loading: false,
        error:false,
        ErrorMessage: 'Retrieve Success',
        success:true,
        results: action.payload
        }; 
        case PLANTATION_EDIT_SUCCESS:
        return {    
        ...state,
        isSwitchSnackbarOn: true,
        isSnackbarError: false,
        loading: false,
        error:false, 
        success:true,
        ErrorMessage: 'Edit Success | ' + action.payload,
        }; 
        case CREATE_PLANTATION_SUCCESS:
        return {    
        ...state,
        isSwitchSnackbarOn: true,
        isSnackbarError: false,
        loading: false,
        error:false, 
        success:true,
        created:action.payload,
        ErrorMessage: 'Create Success | ' + action.payload.message,
        };  
        case CREATE_PLANTATION_ERROR:
        return {    
        ...state,
        isSwitchSnackbarOn: true,
        isSnackbarError: false,
        loading: false,
        error:false,
        ErrorMessage: action.payload,
        success:true
        }; 
        case PLANTATION_EDIT_ERROR:
        return {    
        ...state,
        isSwitchSnackbarOn: true,
        isSnackbarError: false,
        loading: false,
        error:false,
        ErrorMessage: action.payload,
        success:true
        }; 
        case CREATE_PLANTATION_POST_ERROR:
          return {
              ...state, 
              error: state.error,
              loading:false,
              success: false,
              isSnackbarError: true,
              isSwitchSnackbarOn: true,
              ErrorMessage: "PLANTATION POST ERROR | CONTACT NETWORK ADMINISTRATOR",
          }
          break; 
      case PLANTATION_VIEW_POST_ERROR:
        return {
            ...state, 
            error: state.error,
            loading:false,
            success: false,
            isSnackbarError: true,
            isSwitchSnackbarOn: true,
            ErrorMessage: "PLANTATION POST ERROR | CONTACT NETWORK ADMINISTRATOR",
        }
        break; 
    case PLANTATION_VIEW_ERROR:
        return {    
        ...state,
        isSwitchSnackbarOn: true,
        isSnackbarError: true,
        loading: false,
        ErrorMessage: action.payload,
        error:true,
        success:false
        };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/plantationReducer.js